import { uppercaseFirstLetter } from '../TrackingTimeline.service';
import {
  AdditionalInfoName,
  AdditionalInfoValue,
} from '../TrackingTimeline.styles';

interface AdditionalInfoProps {
  name: string;
  value: string;
}

export const AdditionalInfo = ({
  name,
  value,
}: AdditionalInfoProps): JSX.Element => {
  return (
    <div>
      <AdditionalInfoName>{name}</AdditionalInfoName>:{' '}
      <AdditionalInfoValue>{uppercaseFirstLetter(value)}</AdditionalInfoValue>
    </div>
  );
};
